import { createFileRoute, notFound } from "@tanstack/react-router";
import { queries } from "@theprelude/core";
import { setPageTitle } from "@/components/app-shell/app-shell";
import { NotificationForm } from "@/components/notifications/notification-form";

import { authorizeFeatures } from "@/lib/authorize-feature";

export const Route = createFileRoute("/_app/account/notifications/edit/$id")({
  beforeLoad: () => setPageTitle("Edit Notification"),
  loader: async ({ context, params }) => {
    await authorizeFeatures(context, ["policy_evaluator"]);
    const authConfig = await context.auth.getAuthConfig();
    const notifications = await context.queryClient.ensureQueryData(
      queries.scm.notifications(authConfig),
    );
    const notification = notifications.find((n) => n.id === params.id);
    if (!notification) {
      throw notFound();
    }
    return notification;
  },
  component: EditNotificationPage,
  gcTime: 0,
});

function EditNotificationPage() {
  const notification = Route.useLoaderData();

  return (
    <div className="flex w-full flex-col gap-4 p-6">
      <div className="flex min-h-[38px] items-center justify-between">
        <h1 className="text-2xl dark:font-light">Edit Notification</h1>
      </div>
      <div className="border-b border-stroke-line" />
      <NotificationForm notification={notification} />
    </div>
  );
}
